import React from "react";
import { Group, Divider } from "@mantine/core";
import { shallow } from "zustand/shallow";
import { useTranslation } from "react-i18next";

import Intervals from "./Intervals";
import { Counter } from "@components/shared";
import { CustomTooltip } from "@components/shared";
import useAppStore from "./contest-settings-store";
import { contestSettingsText } from "@components/Contest/helpers";

export default function Keywords({ beginDate, endDate, onUpdate }) {
  const { t } = useTranslation();
  const { settings, setSettings } = useAppStore(
    (state) => ({
      settings: state.settings,
      setSettings: state.setSettings,
    }),
    shallow
  );

  const counterFields = [
    {
      title: t("mixer:contest_settings:keyword_use_total_title"),
      keyName: "keyword_use_total",
      tooltipText: t("mixer:contest_settings:keyword_use_total_tooltip"),
    },
    {
      title: t("mixer:contest_settings:keyword_value_title"),
      keyName: "keyword_value",
      unlimited: false,
      tooltipText: t("mixer:contest_settings:keyword_value_tooltip"),
    },
    {
      title: t("mixer:contest_settings:keyword_total_entries_allowed_title"),
      keyName: "total_entries_allowed",
      tooltipText: t(
        "mixer:contest_settings:keyword_total_entries_allowed_tooltip"
      ),
    },
  ].map((m, i) => ({
    ...m,
    key: i + 1,
    value: settings.keywords[m.keyName],
  }));

  return (
    <div>
      {counterFields.map((c) => (
        <Group key={c.key}>
          <div style={{ minWidth: "200px" }}>
            <Counter
              value={c.value}
              unlimited={c.unlimited}
              onChange={(e) =>
                onUpdate({
                  [c.keyName]: e,
                })
              }
            />
          </div>
          <CustomTooltip label={c.tooltipText}>
            <h3 style={{ margin: "0" }}>{c.title}</h3>
          </CustomTooltip>
        </Group>
      ))}
      <Divider mt="lg" mb="lg" />
      <Intervals
        beginDate={beginDate}
        endDate={endDate}
        items={settings.keywords.intervals}
        title={t("common:interval_plural")}
        onChange={(e) => onUpdate({ intervals: e })}
      />
    </div>
  );
}
